<script >
import { computed, ref } from 'vue-demi';
import { CMP_NAME_CLOSE_BTN, TIME_LIMIT, HIDE_TYPE, DISPLAY_TYPE } from '../constants';
import useJudgeOverFirstScreen from './composable/useJudgeOverFirstScreen';
import useCmpInScreenHide from './composable/useCmpInScreenHide';
import usePureDisplayClose from './composable/usePureDisplayClose';
import CloseBtn from '../components/close-btn/render/index.vue';
import FEGORender from '@futuweb/fego-render';
const {
  renderer
} = FEGORender;
const __sfc_main = {
  name: 'fixed-box',
  components: {
    renderer,
    CloseBtnCmp: {
      extends: renderer,
      methods: {
        async getCmp() {
          return CloseBtn;
        },
        renderFn(h) {
          const listeners = Object.assign({}, this.renderData.on, this.$listeners);
          const payload = Object.assign({}, this.renderData, {
            on: listeners
          });
          return h(this.cmp, payload);
        }
      }
    }
  }
};
__sfc_main.props = {
  tpl: {
    type: Object,
    default: () => ({})
  },
  // 是否使用关闭按钮
  enableCloseBtn: {
    type: Boolean,
    default: false
  },
  // 关闭时限
  closeTimeLimit: {
    type: String,
    default: TIME_LIMIT.ONCE
  },
  hideType: {
    type: String,
    default: HIDE_TYPE.FIRST_SCREEN
  },
  // 是否首屏显示开关
  isFirstScreenHide: {
    type: Boolean,
    default: false
  },
  // 在屏幕内隐藏吸底按钮的组件
  cmpInScreenHide: {
    type: Array,
    default: () => []
  },
  zIndex: {
    type: String,
    default: ''
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    library,
    store: {
      variable
    }
  } = require('@futuweb/fego-render');
  const {
    state: {
      initCmpStateMatchine
    },
    rem: {
      parseStyle
    },
    cmp: {
      isBox
    }
  } = require('@futuweb/fego-bridge');
  const {
    usePageType,
    useTeleport
  } = require('@fegobull/webapi').use;
  const {
    ramda: R
  } = library;
  const {
    isPC
  } = usePageType();
  const props = __props;

  // 相对视窗定位组件，处理挂载到 body 下。
  useTeleport(document.body);
  let displayBox = ref(DISPLAY_TYPE.HIDDEN);
  let close = () => {
    displayBox.value = DISPLAY_TYPE.CLOSE;
  };
  if (props.hideType === HIDE_TYPE.FIRST_SCREEN && props.isFirstScreenHide) {
    const {
      displayBox: innerDisplayBox,
      close: innerClose
    } = useJudgeOverFirstScreen({
      enableCloseBtn: props.enableCloseBtn,
      closeTimeLimit: props.closeTimeLimit
    });
    displayBox = innerDisplayBox;
    close = innerClose;
  } else if (props.hideType === HIDE_TYPE.CMP_IN_SCREEN && props.cmpInScreenHide?.length) {
    const {
      displayBox: innerDisplayBox,
      close: innerClose
    } = useCmpInScreenHide({
      enableCloseBtn: props.enableCloseBtn,
      closeTimeLimit: props.closeTimeLimit,
      cmpInScreenHide: props.cmpInScreenHide
    });
    displayBox = innerDisplayBox;
    close = innerClose;
  } else {
    const {
      displayBox: innerDisplayBox,
      close: innerClose
    } = usePureDisplayClose({
      enableCloseBtn: props.enableCloseBtn,
      closeTimeLimit: props.closeTimeLimit
    });
    displayBox = innerDisplayBox;
    close = innerClose;
  }
  const boxStyle = computed(() => {
    const {
      style
    } = props.tpl;
    const r = Object.assign({
      position: 'relative'
    }, style);
    const extraStyle = {
      overflow: 'visible!important'
    };
    if (isPC) {
      // PC下宽度撑满 以便设置背景色
      extraStyle.width = '100%!important';
    }
    if (props.zIndex) {
      extraStyle.zIndex = props.zIndex;
    }
    return Object.assign({}, parseStyle(r), extraStyle);
  });

  // 子组件
  const tpls = computed(() => {
    const {
      children
    } = props.tpl;
    const ret = children.filter(tpl => tpl.type.indexOf(CMP_NAME_CLOSE_BTN) === -1).map((tpl, i) => {
      return R.mergeDeepRight(tpl, initCmpStateMatchine(tpl, variable.data));
    });
    return ret;
  });
  // 关闭按钮
  const closeBtn = computed(() => {
    const {
      children
    } = props.tpl;
    let ret = null;
    if (props.enableCloseBtn) {
      const tpl = children.find(_tpl => _tpl.type.indexOf(CMP_NAME_CLOSE_BTN) > -1);
      if (tpl) {
        ret = R.mergeDeepRight(tpl, initCmpStateMatchine(tpl, variable.data));
      }
    }
    return ret;
  });

  // 子组件样式, 除了box类型的子组件，均用setStyle设置样式，box自身有自己的处理方式
  const setStyle = tpl => {
    const {
      style
    } = tpl;
    const fn = () => {
      const isBoxChild = isBox(tpl);
      if (isBoxChild) {
        //本身boxStyle有处理，避免传到子容器，把子容器自己的样式覆盖了
        return;
      }
      return Object.assign({}, style, {
        position: 'absolute'
      });
    };
    const s = fn();
    return s && parseStyle(s);
  };
  return {
    DISPLAY_TYPE,
    isPC,
    displayBox,
    close,
    boxStyle,
    tpls,
    closeBtn,
    setStyle
  };
};
__sfc_main.components = Object.assign({
  renderer
}, __sfc_main.components);
export default __sfc_main;
</script>

<template>
    <div :class="['fixed-box', {
        isPC
    }]">
        <div
            v-show="displayBox === DISPLAY_TYPE.DISPLAY"
            class="box"
            :style="boxStyle"
        >
            <div class="container">
                <renderer
                    v-for="tpl of tpls"
                    :key="tpl.id"
                    :style="setStyle(tpl)"
                    :tpl="tpl"
                ></renderer>
                <close-btn-cmp
                    v-if="closeBtn"
                    :tpl="closeBtn"
                    :style="setStyle(closeBtn)"
                    @click="close"
                />
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
.fixed-box {
    height: 0!important;
    width: 100%!important;
    .box {
        position: fixed!important;
        z-index: 100;
        top: auto!important;
        left: 0;
        right: 0;
        margin: auto;
        bottom: 0;
    }
    .container {
        position: relative;
        margin: auto;
    }
    &.isPC {
        .container {
            width: 12rem!important;
        }
    }
}
</style>
